import accessPointsAccessMethodsSagas from './sagas/access-points/accessPointsAccessMethodsSagas';
import accessPointsSagas from 'store/sagas/access-points/accessPointsSagas';
import accountInvitationsSagas from 'store/sagas/accountInvitationsSagas';
import accountsSagas from 'store/sagas/accountsSagas';
import accountUsersSagas from 'store/sagas/accountUsersSagas';
import accountYieldSagas from 'store/sagas/accountYieldsSagas';
import accumulateSagas from 'store/sagas/accumulateSagas';
import apiKeysSagas from 'store/sagas/apiKeysSagas';
import authSagas from 'store/sagas/authSagas';
import bookingsSagas from 'store/sagas/bookings/bookingsSagas';
import bookingReservationsSagas from 'store/sagas/bookings/bookingReservationsSagas';
import bookingStatsSagas from 'store/sagas/bookings/bookingStatsSagas';
import campaignsSagas from 'store/sagas/campaignsSagas';
import categoriesSagas from 'store/sagas/categoriesSagas';
import currentAccountSagas from 'store/sagas/currentAccountSagas';
import dashboardSagas from 'store/sagas/dashboardSagas';
import discountsCodesSagas from 'store/sagas/discountsCodesSagas';
import discountsSagas from 'store/sagas/discountsSagas';
import invoicesSagas from 'store/sagas/invoices/invoicesSagas';
import orderActivitiesSagas from 'store/sagas/orderActivitiesSagas';
import orderSagas from 'store/sagas/orderSagas';
import paymentSlipSagas from 'store/sagas/paymentSlipSagas';
import pointOfInterestSagas from 'store/sagas/pointOfInterestSagas';
import pointOfInterestImagesSagas from 'store/sagas/pointsOfInterestImagesSagas';
import productsSagas from 'store/sagas/productsSagas';
import productAvailabilitySagas from 'store/sagas/productAvailabilitySagas';
import productConfigurationSagas from 'store/sagas/productConfigurationSagas';
import productImagesSagas from 'store/sagas/product/productImagesSagas';
import productLocalisationSagas from 'store/sagas/productLocalisationSagas';
import productOccupancySagas from 'store/sagas/product/productOccupancySagas';
import productPropertiesSagas from 'store/sagas/productPropertiesSagas';
import productRelatedSagas from 'store/sagas/productRelatedSagas';
import productResourceSagas from 'store/sagas/productResourceSagas';
import profileSagas from 'store/sagas/profileSagas';
import propertiesSagas from 'store/sagas/propertiesSagas';
import propertygroupsSagas from 'store/sagas/propertygroupsSagas';
import reservationSessionActivitiesSagas from 'store/sagas/reservationAccessSessionActivitiesSagas';
import reservationSessionSagas from 'store/sagas/reservationSessionSagas';
import reservationsSagas from 'store/sagas/reservationsSagas';
import subcategoriesSagas from 'store/sagas/subcategoriesSagas';
import transactionsSagas from 'store/sagas/transactions/transactionsSagas';
import translateSagas from 'store/sagas/utilities/translateSagas';
import userImpersonationSagas from 'store/sagas/users/impersonationSagas';
import usersPasswordSagas from 'store/sagas/usersPasswordSagas';
import usersSagas from 'store/sagas/usersSagas';
import voucherSagas from 'store/sagas/voucherSagas';
import webhooksSagas from 'store/sagas/webhooksSagas';
import productMembershipsSagas from './sagas/productMembershipSagas';
import membershipSchedulesSagas from './sagas/membershipSchedulesSagas';
import userProductMembershipSagas from './sagas/userProductMembershipSagas';
import membershipsPoolsSagas from './sagas/memberships/membershipPoolsSagas';

export default [
    accessPointsAccessMethodsSagas,
    accessPointsSagas,
    accountsSagas,
    accountInvitationsSagas,
    accountUsersSagas,
    accountYieldSagas,
    accumulateSagas,
    apiKeysSagas,
    authSagas,
    bookingReservationsSagas,
    bookingStatsSagas,
    bookingsSagas,
    campaignsSagas,
    categoriesSagas,
    currentAccountSagas,
    dashboardSagas,
    discountsCodesSagas,
    discountsSagas,
    invoicesSagas,
    membershipSchedulesSagas,
    userImpersonationSagas,
    orderActivitiesSagas,
    orderSagas,
    paymentSlipSagas,
    pointOfInterestSagas,
    pointOfInterestImagesSagas,
    productAvailabilitySagas,
    productLocalisationSagas,
    productOccupancySagas,
    productPropertiesSagas,
    productRelatedSagas,
    productResourceSagas,
    productImagesSagas,
    productsSagas,
    profileSagas,
    propertiesSagas,
    propertygroupsSagas,
    productConfigurationSagas,
    productMembershipsSagas,
    reservationSessionActivitiesSagas,
    reservationSessionSagas,
    reservationsSagas,
    subcategoriesSagas,
    transactionsSagas,
    translateSagas,
    usersPasswordSagas,
    usersSagas,
    userProductMembershipSagas,
    voucherSagas,
    webhooksSagas,
    membershipsPoolsSagas,
];



// WEBPACK FOOTER //
// ./src/store/sagas.js